// eslint-disable-next-line
export const makeUserApiEndpoints = (userId = ":userId") => {
  const endpoints = {
    userItem: (id = "") => `/users/${id || userId}`,
    userEmail: (id = "") => `/users/${id || userId}/email`,
    userPassword: (id = "") => `/users/${id || userId}/password`,
    userPasswordReset: (id = "") => `/users/password-reset`,
    userEmailVerify: (id = "") => `/users/${id || userId}/email/verify`,
    userEmailChangeRequest: (id = "") => `/users/${id || userId}/email-change-request`,
    userInfo: () => `/auth/userinfo`,
    userNotificationSettings: (id = "") => `/users/${id || userId}/notification-settings`,
    sendWelcomeEmail: () => `/users/send-welcome-email`,
  }
  return endpoints
}
